import { createTheme, colorsTuple, type MantineColorsTuple } from "@mantine/core";

// ── Primitive palettes (ported from UnitLogic.Client PrimitivesSL) ──────────
// 10 shades per palette: [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]
// Kept in sync with UnitLogic.Client/src/lib/theme.ts so this bundle drops
// straight into that app later.

const brand: MantineColorsTuple = [
  "#ebf3fc",
  "#CBEDFF",
  "#8CD7FF",
  "#4DC1FF",
  "#0DACFF",
  "#0086CD",
  "#005D8E",
  "#00496F",
  "#003551",
  "#002132",
];
const neutral: MantineColorsTuple = [
  "#F8FAFC",
  "#F1F5F9",
  "#E2E8F0",
  "#CBD5E1",
  "#94A3B8",
  "#64748B",
  "#4F5B6D",
  "#394250",
  "#242A32",
  "#0F1114",
];
const red: MantineColorsTuple = [
  "#FEF2F2",
  "#FEE2E2",
  "#FECACA",
  "#FCA5A5",
  "#F87171",
  "#EF4444",
  "#DC2626",
  "#B91C1C",
  "#991B1B",
  "#7F1D1D",
];
const orange: MantineColorsTuple = [
  "#FFF7ED",
  "#FFEDD5",
  "#FED7AA",
  "#FDBA74",
  "#FB923C",
  "#F97316",
  "#EA580C",
  "#C2410C",
  "#9A3412",
  "#7C2D12",
];
const amber: MantineColorsTuple = [
  "#FFFBEB",
  "#FEF3C7",
  "#FDE68A",
  "#FCD34D",
  "#FBBF24",
  "#F59E0B",
  "#D97706",
  "#B45309",
  "#92400E",
  "#78350F",
];
const yellow: MantineColorsTuple = [
  "#FEFCE8",
  "#FEF9C3",
  "#FEF08A",
  "#FDE047",
  "#FACC15",
  "#EAB308",
  "#CA8A04",
  "#A16207",
  "#854D0E",
  "#713F12",
];
const green: MantineColorsTuple = [
  "#F0FDF4",
  "#DCFCE7",
  "#BBF7D0",
  "#86EFAC",
  "#4ADE80",
  "#22C55E",
  "#16A34A",
  "#15803D",
  "#166534",
  "#14532D",
];
const teal: MantineColorsTuple = [
  "#F0FDFA",
  "#CCFBF1",
  "#99F6E4",
  "#5EEAD4",
  "#2DD4BF",
  "#14B8A6",
  "#0D9488",
  "#0F766E",
  "#115E59",
  "#134E4A",
];
const cyan: MantineColorsTuple = [
  "#ECFEFF",
  "#CFFAFE",
  "#A5F3FC",
  "#67E8F9",
  "#22D3EE",
  "#06B6D4",
  "#0891B2",
  "#0E7490",
  "#155E75",
  "#164E63",
];
const blue: MantineColorsTuple = [
  "#EFF6FF",
  "#DBEAFE",
  "#BFDBFE",
  "#93C5FD",
  "#60A5FA",
  "#3B82F6",
  "#2563EB",
  "#1D4ED8",
  "#1E40AF",
  "#1E3A8A",
];
const violet: MantineColorsTuple = [
  "#F5F3FF",
  "#EDE9FE",
  "#DDD6FE",
  "#C4B5FD",
  "#A78BFA",
  "#8B5CF6",
  "#7C3AED",
  "#6D28D9",
  "#5B21B6",
  "#4C1D95",
];

const BASE_RADIUS = 4;

const radius = {
  xs: `${BASE_RADIUS * 0.5}px`,
  sm: `${BASE_RADIUS}px`,
  md: `${BASE_RADIUS * 2}px`,
  lg: `${BASE_RADIUS * 4}px`,
  xl: `${BASE_RADIUS * 8}px`,
};

export const theme = createTheme({
  fontFamily: "DIN, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  headings: {
    fontFamily: "DIN, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  colors: {
    // brand palette — primary[6] = #005D8E
    primary: brand,
    secondary: brand,
    subtle: colorsTuple("#6C7F89"),
    destructive: colorsTuple("#EF4444"),
    muted: colorsTuple("#F1F5F9"),
    mutedForeground: colorsTuple("#94A3B8"),
    foreground: colorsTuple("#242A32"),
    neutral,
    red,
    orange,
    amber,
    yellow,
    green,
    teal,
    cyan,
    blue,
    violet,
  },
  primaryColor: "primary",
  radius,
  defaultRadius: "md",
  cursorType: "pointer",
});
